import { supabase } from '@/utils/supabase/client';
import { AuthError } from '@supabase/supabase-js';

// Supabase Auth captcha (Turnstile) is enforced on sign-in, sign-up, password
// recovery and magic-link; verifyOtp / updateUser do not take a token.
type Captcha = { captchaToken?: string };

const signIn = async ({ email, password, captchaToken }: { email: string; password: string } & Captcha): Promise<any> => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
    options: { captchaToken },
  });
  if (error) {
    throw new Error(error.message);
  }
  return data;
};

const signUp = async ({ email, password, options, captchaToken }): Promise<any> => {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: { ...options, captchaToken },
  });

  if (error) {
    throw new Error(error.message);
  }
  return data;
};
const forgotPassword = async ({ email, captchaToken }: { email: string } & Captcha): Promise<AuthError> => {
  const { error } = await supabase.auth.resetPasswordForEmail(email, { captchaToken });

  if (error) {
    throw new Error(error.message);
  }
  return error;
};

const verifyOtp = async ({ email, token, type }): Promise<AuthError> => {
  const { error } = await supabase.auth.verifyOtp({
    email,
    token,
    type,
  });
  if (error) {
    throw new Error(error.message);
  }
  return error;
};

const newPassword = async ({ password }): Promise<AuthError> => {
  const { error } = await supabase.auth.updateUser({
    password,
  });
  return error;
};

const signInWithMagicLink = async ({ email, captchaToken }: { email: string } & Captcha): Promise<any> => {
  const { data, error } = await supabase.auth.signInWithOtp({
    email,
    options: {
      shouldCreateUser: false,
      emailRedirectTo: `${window.location.origin}/auth/confirm?next=/app`,
      captchaToken,
    },
  });
  if (error) {
    throw new Error(error.message);
  }
  return data;
};

export { signIn, signUp, verifyOtp, forgotPassword, newPassword, signInWithMagicLink };
